/**
 * @license @lucide/vue v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { h } from 'vue';
import Icon from './Icon.mjs';

const createLucideIcon = (iconName, iconNode) => (props, { slots, attrs }) => h(
  Icon,
  {
    ...attrs,
    ...props,
    iconNode,
    name: iconName
  },
  slots
);

export { createLucideIcon as default };
//# sourceMappingURL=createLucideIcon.mjs.map
